import {ListItemsTableSettings} from "components/common";
import {Text} from "@mantine/core";
import {RoutesResolver} from "routes";
import {ISupplier} from "features/suppliers";

interface TableSettingProps {
    routesResolver: RoutesResolver,
}

export type TTableSettings =
    (props: TableSettingProps) =>
        ListItemsTableSettings<ISupplier & { id: number }, void>[];

export const TableSettings: TTableSettings = (
    {
        routesResolver,
    }: TableSettingProps) => [
    {
        key: 'name',
        label: "Name",
        isNotFormValue: true,
        Render: {
            Static: function ({data}) {
                const {name} = data;
                return <Text>{name}</Text>
            },
        }
    },
]